import type { AreaCode } from '@ebalance/proto/bfftypes/v1/area_pb'
import { useTranslation } from 'react-i18next'

import { HStack, Link, Text } from '@enechain/ecloud-designsystem'

import { buildSelectedAreasLabel } from '~/components/bidding/common/areaLabel'

type Props = {
  selectedAreas: ReadonlySet<AreaCode>
  onClear: () => void
}

/** AC-BSP-132: 共通ツールバーのエリア絞り込みを、両入札一覧の見出しで明示する。 */
export const AreaFilterSummary = ({
  selectedAreas,
  onClear,
}: Props): React.ReactElement | null => {
  const { t } = useTranslation()
  if (selectedAreas.size === 0) return null

  return (
    <HStack gap={2} minWidth={0}>
      <Text
        textStyle="captionNormal"
        color="Text.midEmphasis"
        lineHeight={1.2}
        whiteSpace="nowrap"
      >
        {t('page:biddingSpot.list.areaFiltered', {
          areas: buildSelectedAreasLabel(new Set(selectedAreas)),
        })}
      </Text>
      <Link fontSize="sm" lineHeight={1.2} asChild>
        <button onClick={onClear} type="button">
          {t('page:biddingSpot.list.clearAreaFilter')}
        </button>
      </Link>
    </HStack>
  )
}
